import React from 'react'
import  { useRoutes } from 'react-router-dom'
import { userInfo as recoilUserInfo } from './recoil';
import { MainLayout } from './layout'
import { useRecoilValue } from 'recoil'
import NoPermission from './views/developerCenter/exception/403';
import { developerCenterRoutes } from './common/routes';

export function GlobalRoutes (){
  const userInfo = useRecoilValue(recoilUserInfo)
  const isDEVELOPER = userInfo?.roles?.some((role: any) => role.code === 'DEVELOPER')
  const globalRoutes = useRoutes([
    {
      path: '/',
      element: <MainLayout/>,
      children: isDEVELOPER ? [
        ...developerCenterRoutes
      ] : [
        ...developerCenterRoutes.map((item) => {
          if(item.canAccessRole && item.canAccessRole.includes('DEVELOPER')){
            return {
              ...item,
              element: <NoPermission/>
            }
          }
          return item
        })
      ]
    }
  ])

  return globalRoutes
}
